import React, { Component } from "react";
import Select from "react-select";

export default class SelectDropdown extends Component {
  render() {
    return (
      <div className="col-sm-10">
        <Select
          placeholder="Please Choose An Option"
          options={this.props.options}
          onChange={this.props.onChange}
          value={this.props.value ? this.props.value : null}
          className="react-select-container  checkValidate"
          classNamePrefix="react-select"
          styles={{
            control: (provided) => ({
              ...provided,
              border: this.props.isError
                ? "1px solid red"
                : "1px solid #e5e5e5",
              cursor: "pointer",
            }),
          }}
        />
      </div>
    );
  }
}
